const abstractFetch = (requestObject) => {
	return fetch(process.env.REACT_APP_GISSERVER_URL, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		},
		method: 'POST',
		body: new URLSearchParams(requestObject),
	})
		.then((res) => res.json())
		.then((data) => {
			return data;
		});
};

export { abstractFetch };
